import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "indicator", "slide"]

  static ANIMATION_DELAY = 4000

  connect() {
    this.currentIndex = 0
    this.updateIndicators()
    this.updateSlideAria()
    this.isAutoScrolling = false
    this.startAutoScroll()
  }

  disconnect() {
    this.stopAutoScroll()
  }

  next(event) {
    if (this.currentIndex < this.listTarget.children.length - 1) {
      this.currentIndex++
    } else {
      this.currentIndex = 0 // Reset to the first card
    }
    this.updateCarousel(event)
  }

  prev(event) {
    if (this.currentIndex > 0) {
      this.currentIndex--
    } else {
      this.currentIndex = this.listTarget.children.length - 1 // Go to the last card
    }
    this.updateCarousel(event)
  }

  goTo(event) {
    const index = event.currentTarget.dataset.carouselSlide
    this.currentIndex = parseInt(index)
    this.updateCarousel()
  }

  updateCarousel(event) {
    if (this.listTarget.children.length == 0) return

    const offset = this.currentIndex * this.listTarget.children[0].clientWidth
    this.listTarget.scrollTo({ left: offset, behavior: "smooth" }) 
    this.updateIndicators()
    this.updateSlideAria()
    if (event) {
      this.stopAutoScroll()
    }
  }

  updateIndicators() {
    this.indicatorTargets.forEach((indicator, index) => {
      const isActive = index === this.currentIndex
      indicator.style.backgroundColor = isActive ? "red" : "gray"
      indicator.setAttribute("aria-current", String(isActive))
    })
  }

  updateSlideAria() {
    // Update aria-current on slides if they exist as targets
    if (this.hasSlideTarget) {
      this.slideTargets.forEach((slide, index) => {
        const isActive = index === this.currentIndex
        slide.setAttribute("aria-current", String(isActive))
      })
    }
  }

  startAutoScroll() {
    this.stopAutoScroll()

    this.interval = setInterval(() => {
      this.isAutoScrolling = true
      this.next()
      setTimeout(() => {
        this.isAutoScrolling = false
      }, 500)
    }, this.constructor.ANIMATION_DELAY)
  }

  stopAutoScroll() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  }

  mouseenter() {
    this.stopAutoScroll()
  }

  mouseleave() {
    this.startAutoScroll()
  }

  touchmove() {
    this.stopAutoScroll()
  }

  scroll() {
    if (this.listTarget.children.length == 0) return
    
    if (this.interval && !this.isAutoScrolling) {
      this.stopAutoScroll()
    }
    const styles = window.getComputedStyle(this.listTarget)
    const gap = Number.parseFloat(styles.columnGap || styles.gap || "0") || 0
    let active = this.listTarget.scrollLeft / (this.listTarget.children[0].clientWidth + gap)
    let isAtRight = this.listTarget.scrollLeft + this.listTarget.clientWidth >= this.listTarget.scrollWidth - 1
    if (isAtRight) {
      this.currentIndex = this.listTarget.children.length - 1
    } else {
      this.currentIndex = Math.round(active)
    }
    this.updateIndicators()
  }
}
